import { render, staticRenderFns } from "./GoogleMapPanel.vue?vue&type=template&id=60ced04d&scoped=true&"
import script from "./GoogleMapPanel.vue?vue&type=script&lang=ts&"
export * from "./GoogleMapPanel.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleMapPanel.vue?vue&type=style&index=0&id=60ced04d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ced04d",
  null
  
)

export default component.exports
import {QCard,QTabs,QTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTabs,QTab,QTabPanels,QTabPanel})
